import { Component, ViewChild, AfterViewInit, OnInit, Inject, ElementRef } from '@angular/core';
import { HttpClient, HttpRequest, HttpEventType, HttpParams, HttpResponse } from '@angular/common/http';
import { MachineService } from '../services/machine-service';
import { ContractService } from '../services/contract-service';
import { MasterService } from '../services/master-service';
import { ReportService } from '../services/report-service';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { CommonService } from '../services/common-service';

//import * as $ from './node_modules/jquery/dist/jquery.js';

//grid
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import { jqxDropDownListComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxdropdownlist';
import { jqxInputComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxinput';
import { jqxWindowComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxwindow';
import { jqxEditorComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxeditor';
import { jqxLoaderComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxloader';

@Component({
  templateUrl: '../main.component.html'
})

export class MachineListComponent implements OnInit {
  public menuName = "Machine";
  public titleName = "Machine";
  public clickOpen = "Rowdoubleclick($event)";
  //public rowscount = 0;
  public edited = false;
  public isSearchDate = false;

  @ViewChild('cellBeginEditLog') cellBeginEditLog: ElementRef;
  @ViewChild('cellEndEditLog') cellEndEditLog: ElementRef;
  @ViewChild('myGrid') myGrid: jqxGridComponent;
  @ViewChild('myDropDownList') myDropDownList: jqxDropDownListComponent;
  @ViewChild('myInput') myInput: jqxInputComponent;
  @ViewChild('myWindow') myWindow: jqxWindowComponent;
  @ViewChild('MyLoader') MyLoader: jqxLoaderComponent;

  delrows: Array<any> = [];
  selectedcell: any;
  errorMessage: any;
  successMessage: any;
  contractContent: any;
  first_flg: boolean = true;
  loading_flg: boolean = true;

  //get source
  constructor(private _machineService: MachineService, private _contractService: ContractService, @Inject('BASE_URL') baseUrl: string,
    private _reportService: ReportService, private _masterService: MasterService, private _router: Router, public dialog: MatDialog, private _com: CommonService) {
  }

  ngOnInit() {
    this.getDevicesDropDown();
    this.getMachines();
    // this.getContractsDropDown();
  }

  getMachines() {
    this.loading_flg = true;
    if (!(this.first_flg)) {
      this.MyLoader.open();
    }
    this._machineService.getMachines(false).subscribe((data) => {
      this.source.localdata = data;
      //this.rowscount = data.length;
      this.dataAdapter.dataBind();
      if (!(this.first_flg)) {
        this.MyLoader.close();
      }
      this.first_flg = false;
      this.loading_flg = false;
    });
  }

  getDevicesDropDown() {
    //this._masterService.getDevicesForDropDown().subscribe((data) => {
    //  this.devicesSource.localdata = data;
    //});
    this._masterService.getDevices(true).subscribe((data) => {
      this.devicesSource.localdata = data;
    });
  }

  //Popup
  Rowdoubleclick(event: any): void {
    let selectedrowindex = this.myGrid.getselectedrowindex();
    let id = this.myGrid.getrowdata(selectedrowindex).machine_id;
    let dialogRef = this.dialog.open(PopupMachineComponent, {
      width: '1000px',
      //height: 'auto*',
      disableClose: true,//20191007 close無し
      data: {
        machine_id: id
      }
    });

    dialogRef.afterClosed().subscribe(
      (result) => {
        //20191008 自分のタイミングで更新するように
        //this.getMachines();
      });
  }

  //tool bar
  ngAfterViewInit(): void {
    this.createButtons();
  }

  //dropDownSource: string[] = ['Contract#', 'MAC', 'Order#', 'Warranty', 'Contract#', 'Lent', 'Returned', 'Remarks', 'Dispose'];
  //08/16/2019 Warranty 不要
  //dropDownSource: string[] = ['MAC', 'Contract#', 'Order#', 'Warranty', 'Lent', 'Returned', 'Remarks', 'Dispose'];
  dropDownSource: string[] = ['MAC', 'Contract#', 'Order#', 'Lent', 'Returned', 'Remarks', 'Dispose'];

  groups: any[] = [];
  getPagesize(): any {
    return 20;
  }
  //grid 
  source: any =
    {
      datatype: 'json',
      datafields: [
        { name: 'machine_id', type: 'int' },
        { name: 'contract_id', type: 'int' },
        { name: 'device_id', type: 'int' },
        //{ name: 'mac_address', type: 'string', map: 'device>mac_address' },
        //{ name: 'order_no', type: 'string', map: 'device>order_no' },
        //{ name: 'warranty', type: 'date', map: 'device>warranty' },
        { name: 'mac_address', type: 'string' },
        { name: 'order_no', type: 'string' },
        //{ name: 'warranty', type: 'date' },　//08/16/2019 Warranty 不要
        { name: 'lent', type: 'date' },
        { name: 'returned', type: 'date' },
        { name: 'remarks', type: 'string' },
        { name: 'dispose_flg', type: 'bool' }
      ],
      id: 'machine_id',
      localdata: {},
      sortcolumn: 'machine_id'
    };
  dataAdapter: any = new jqx.dataAdapter(this.source);

  getWidth(): any {
    return '100%';
  }
  getTotal(): any {
    return false;
  }

  contractsSource: any =
    {
      //datatype: 'array',
      datatype: 'array',
      datafields: [
        { name: 'contract_id', type: 'int' },
        { name: 'contract_no', type: 'string' }
      ],
      localdata: {}
    };
  contractsAdapter: any = new jqx.dataAdapter(this.contractsSource, { autoBind: true });

  contractValue: any =
    {
      //datatype: 'array',
      datatype: 'array',
      datafields: [
        { name: 'mac_address', type: 'string' },
        { name: 'order_no', type: 'string' },
        { name: 'warranty', type: 'date' }
      ],
      localdata: {}
    };
  //contractValueAdapter: any = new jqx.dataAdapter(this.contractValue, { autoBind: true });

  devicesSource: any =
    {
      //datatype: 'array',
      datatype: 'array',
      datafields: [
        { name: 'device_id', type: 'int' },
        { name: 'mac_address', type: 'string' },
        { name: 'order_no', type: 'string' },
        { name: 'warranty', type: 'datetime' }
      ],
      localdata: {}
    };
  devicesAdapter: any = new jqx.dataAdapter(this.devicesSource, { autoBind: true });

  //columns
  columns: any[] =
    [
      //{
      //  text: 'Contract#', datafield: 'contract_id', displayfield: 'contract_no', width: '10%', columntype: 'dropdownlist',
      //  createeditor: (row: number, column: any, editor: any): void => {
      //    // assign a new data source to the dropdownlist.
      //    //let list = ['Admin', 'Super Machine', 'General Machine'];
      //    editor.jqxDropDownList({ autoDropDownHeight: true, source: this.contractsAdapter, valueMember: 'contract_id', displayMember: 'contract_no', placeHolder: "Please Select", });
      //  },
      //  validation: (cell: any, value: any, row: any): any => {
      //    if (value == '') {
      //      return { result: false, message: 'Contract# is required' };
      //    }
      //    //this.getContract(value.value);
      //    //console.log("this.contractValue.mac_address :" + this.contractValue.mac_address);
      //    //console.log("row.mac_address.value :" + row.mac_address.value);
      //    //row.mac_address.value = this.contractValue.mac_address;
      //    //row.order_no.value = this.contractValue.order_no;
      //    //row.warranty.value = this.contractValue.warranty;
      //    return true;
      //  },
      //  //initeditor: function (row, value, editor) {
      //  //  if (value != "") {
      //  //    ////this.getContract(value);
      //  //    //this.getContract(value.value);
      //  //    if (typeof this.contractValue === 'undefined') {
      //  //      this.getContract(value);
      //  //    }
      //  //    console.log("this.contractValue.mac_address :" + this.contractValue.mac_address);
      //  //    console.log("row.mac_address.value :" + row.mac_address.value);
      //  //    row.mac_address.value = this.contractValue.mac_address;
      //  //    row.order_no.value = this.contractValue.order_no;
      //  //    row.warranty.value = this.contractValue.warranty;
      //  //  }
      //  //},
      //  cellvaluechanging: function (row, datafield, columntype, oldvalue, newvalue) {
      //    if (newvalue == '') {
      //      return { result: false, message: 'Contract# is required' };
      //    }
      //    this.getContract(newvalue.value);
      //    console.log("this.contractValue.mac_address :" + this.contractValue.mac_address);
      //    console.log("row.mac_address.value :" + row.mac_address.value);
      //    //row.mac_address.value = this.contractValue.mac_address;
      //    //row.order_no.value = this.contractValue.order_no;
      //    //row.warranty.value = this.contractValue.warranty;
      //    //$('#myGrid').jqxGrid('setcellvalue', row, 'mac_address', this.contractValue.mac_address);
      //    //$('#myGrid').jqxGrid('setcellvalue', row, 'order_no', this.contractValue.order_no);
      //    //$('#myGrid').jqxGrid('setcellvalue', row, 'warranty', this.contractValue.warranty);
      //  },
      //},
      { text: 'Id', datafield: 'machine_id', hidden: true, editable: false },
      {
        text: 'MAC', datafield: 'device_id', displayfield: 'mac_address', width: '20%', columntype: 'dropdownlist', editable: false,
        createeditor: (row: number, column: any, editor: any): void => {
          //editor.jqxDropDownList({ searchMode: 'containsignorecase', autoDropDownHeight: true, source: this.devicesAdapter, valueMember: 'device_id', displayMember: 'mac_address', placeHolder: "Please Select", });
          editor.jqxComboBox({ searchMode: 'containsignorecase', autoComplete:true, source: this.devicesAdapter, valueMember: 'device_id', displayMember: 'mac_address'});
        },
        validation: (cell: any, value: any): any => {
          if (value == '') {
            return { result: false, message: 'MAC is required' };
          }
          return true;
        },
        cellvaluechanging: (row, datafield, columntype, oldvalue, newvalue): void => {
          if (newvalue.name != oldvalue) {
            var obj = this.devicesSource.localdata.find(p => p.device_id == newvalue.value);
            this.myGrid.setcellvalue(row, "order_no", obj.order_no);
            this.myGrid.setcellvalue(row, "warranty", obj.warranty);
          };
        }
      },
      { text: 'Contract#', datafield: 'contract_id', hidden: true, editable: false },
      { text: 'Order#', datafield: 'order_no', width: '10%', columntype: 'textbox', editable: false },
      //{ text: 'Warranty', datafield: 'warranty', width: '10%', columntype: 'datetimeinput', cellsformat: 'MM/dd/yyyy', editable: false }, //08/16/2019 Warranty 不要
      { text: 'Lent', datafield: 'lent', width: '10%', columntype: 'datetimeinput', cellsformat: 'MM/dd/yyyy', editable: false },
      { text: 'Returned', datafield: 'returned', width: '10%', columntype: 'datetimeinput', cellsformat: 'MM/dd/yyyy', editable: false },
      {
        text: 'Remarks', datafield: 'remarks', width: '40%', columntype: 'textbox', editable: false,
        validation: (cell: any, value: any): any => {
          if (value.length > 200) {
            return { result: false, message: 'Remarks Code must be less than 200 letters.' };
          }
          return true;
        }
      },
      { text: 'Dispose', datafield: 'dispose_flg', width: '10%', columntype: 'checkbox', twostatecheckbox: true, align: 'center', editable: false }
    ];

  groupsrenderer(text, group, expanded, data): any {
   var color;
    switch (data.level) {
      case 0:
        color = '#B0BEC5';
        break;
      case 1:
        color = '#CFD8DC';
        break;
      case 2:
        color = '#ECEFF1';
        break;
      case 3:
        color = '#EEEEEE';
        break;
      case 4:
        color = '#F5F5F5';
        break;
      case 5:
        color = '#FAFAFA';
        break;
    } 
    return '<div style="width: 100%; height: 100%; background-color: #CFD8DC; color:Black; line-height:30px;"><span style="font-weight:bold; vertical-align: middle;">' + text + '</span></div>';
  }

  //add row
  generatedata(): any {
    let row = {};
    var today = new Date();
    var todayStr = this._com.getDateTime(new Date());

    row['machine_id'] = 0;
    row['contract_id'] = 0;
    row['device_id'] = 0;
    row['mac_address'] = "";
    row['order_no'] = "";
    //row['warranty'] = null;//08/16/2019 Warranty 不要
    row['lent'] = todayStr;
    row['returned'] = "";
    row['remarks'] = "";
    row['dispose_flg'] = "false";

    return row;
  }

  //tool buttons
  createButtonsContainers(statusbar: any): void {
    let buttonsContainer = document.createElement('div');
    buttonsContainer.style.cssText = 'overflow: hidden; position: relative; margin: 5px;';
    let addButtonContainer = document.createElement('div');
    //let deleteButtonContainer = document.createElement('div');
    let reloadButtonContainer = document.createElement('div');
    //let searchButtonContainer = document.createElement('div');
    //let saveButtonContainer = document.createElement('div');
    addButtonContainer.id = 'addButton';
//    deleteButtonContainer.id = 'deleteButton';
    reloadButtonContainer.id = 'reloadButton';
    //searchButtonContainer.id = 'searchButton';
//    saveButtonContainer.id = 'saveButton';
    addButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
//    deleteButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    reloadButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    //searchButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
//    saveButtonContainer.style.cssText = 'float: right; margin-right: 5px;';
    addButtonContainer.className = 'btn btn-default';
//    deleteButtonContainer.className = 'btn btn-default';
    reloadButtonContainer.className = 'btn btn-default';
    //searchButtonContainer.className = 'btn btn-default';
//    saveButtonContainer.className = 'btn btn-default';
    buttonsContainer.appendChild(addButtonContainer);
//    buttonsContainer.appendChild(deleteButtonContainer);
    buttonsContainer.appendChild(reloadButtonContainer);
    //buttonsContainer.appendChild(searchButtonContainer);
//    buttonsContainer.appendChild(saveButtonContainer);
    statusbar[0].appendChild(buttonsContainer);
  }

  //create tool buttons
  createButtons(): void {
    let addButtonOptions = {
      width: 40, height: 25,
      theme: "material",
      value: "<span class='glyphicon glyphicon-plus' style='color:darkseagreen;' title='Add'></span>"
    }
    let addButton = jqwidgets.createInstance('#addButton', 'jqxButton', addButtonOptions);
    //let deleteButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  value: "<span class='glyphicon glyphicon-remove' style='color:indianred;' title='Delete'></span>"
    //}
    //let deleteButton = jqwidgets.createInstance('#deleteButton', 'jqxButton', deleteButtonOptions);
    let reloadButtonOptions = {
      width: 40, height: 25,
      theme: "material",
      value: "<span class='glyphicon glyphicon-refresh' style='color:darkblue;' title='Reload'></span>"
    }
    let reloadButton = jqwidgets.createInstance('#reloadButton', 'jqxButton', reloadButtonOptions);
    //let searchButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  value: "<span class='glyphicon glyphicon-search' style='color:slategrey;' title='Find'></span>"
    //}
    //let searchButton = jqwidgets.createInstance('#searchButton', 'jqxButton', searchButtonOptions);
    //let saveButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  value: "<span class='glyphicon glyphicon-floppy-disk' style='color:#2E7D32;' title='Save'></span>"
    //}
    //let saveButton = jqwidgets.createInstance('#saveButton', 'jqxButton', saveButtonOptions);

    // add new row.
    addButton.addEventHandler('click', (event: any): void => {
      let id = 0;
      let dialogRef = this.dialog.open(PopupMachineComponent, {
        width: '900px',
        //height: 'auto*',
        disableClose: true,//20191007 close無し
        data: {
          mashine_id: id
        }
      });
      dialogRef.afterClosed().subscribe(
        (result) => {
          //20191008 自分のタイミングで更新するように
          //this.getMachines();
        });
    });
    // delete selected row.
    //deleteButton.addEventHandler('click', (event: any): void => {
    //  let selectedrowindex = this.myGrid.getselectedrowindex();
    //  let rowscount = this.myGrid.getdatainformation().rowscount;
    //  let id = this.myGrid.getrowid(selectedrowindex);
    //  this.myGrid.deleterow(id);
    //  this.delrows.push(id);
    //});
    // reload grid data.
    reloadButton.addEventHandler('click', (event: any): void => {
      this.getMachines();
      this.delrows = [];
      this.selectedcell = null;
    });
    // search for a record.
    //searchButton.addEventHandler('click', (event: any): void => {
    //  this.myWindow.open();
    //  this.myWindow.move(60, 60);
    //});
    // save records.
    //saveButton.addEventHandler('click', (event: any): void => {
    //  this.errorMessage = null;
    //  this.successMessage = 'You have successfully saved the data.';

    //  //confirm changes
    //  let selectedrowindex = this.myGrid.getselectedrowindex();
    //  //console.log("this.selectedcell :" + this.selectedcell);
    //  this.myGrid.endcelledit(selectedrowindex, this.selectedcell, false);

    //  console.log(this.myGrid.getrows());
    //  console.log(this.myGrid.getrows().length);
    //  let rows = this.myGrid.getrows();

    //  for (var i = 0; i < rows.length; i++) {
    //    let machine = this.myGrid.getrowdata(i);
    //    console.log(i);
    //    console.log(machine);
    //    if (machine.device_id == ""
    //      || machine.remarks.length > 200) {
    //      this.errorMessage = "Input is invalid. Please check the data.";
    //      this.successMessage = null;
    //      return;
    //    }
    //  }

    //  //let rows = this.myGrid.getrows();

    //  rows.forEach(machine => {
    //    if (machine.machine_id == 0) {
    //      //console.log("machine :" + machine);
    //      this._machineService.addMachine(machine)
    //        .subscribe(
    //          data => {
    //            //this.getMachines();
    //            let index = this.myGrid.getrowboundindexbyid(machine.machine_id);
    //            machine.machine_id += data;
    //            this.myGrid.setcellvalue(index, "machine_id", data);
    //        },
    //        error => {
    //          this.successMessage = null;
    //          if (error._body != null) {
    //            this.errorMessage += "Some data have not been saved. " + error._body;
    //          } else {
    //            this.errorMessage += error;
    //          }
    //        })
    //    }
    //    else {
    //      this._machineService.updateMachine(machine)
    //        .subscribe(
    //          data => {
    //          //this.getMachines();
    //        },
    //        error => {
    //          this.successMessage = null;
    //          if (error._body != null) {
    //            this.errorMessage += "Some data have not been saved. " + error._body;
    //          } else {
    //            this.errorMessage += error;
    //          }
    //        })
    //    }
    //  });
    //  this.delrows.forEach(machineId => {
    //    if (machineId != 0) {
    //      this._machineService.deleteMachine(machineId).subscribe(
    //        data => {
    //        //this.getMachines();
    //        },
    //        error => {
    //          this.successMessage = null;
    //          if (error._body != null) {
    //            this.errorMessage += "Some data have not been saved. " + error._body;
    //          } else {
    //            this.errorMessage += error;
    //          }
    //        })
    //    }
    //  });
    //  this.delrows = [];
    //  this.selectedcell = null;
    //});
  }

  //find button
  findBtnOnClick(): void {
    this.myGrid.clearfilters();
    let searchColumnIndex = this.myDropDownList.selectedIndex();
    let datafield = '';
    switch (searchColumnIndex) {
      //case 0:
      //  datafield = 'machine_id';
      //  break;
      //case 1:
      //  datafield = 'contract_id';
      //  break;
      //case 2:
      //  datafield = 'contract_no';
      //  break;
      //case 3:
      //  datafield = 'device_id';
      //  break;
      case 0:
        datafield = 'mac_address';
        break;
      case 1:
        datafield = 'contract_id';
        break;
      case 2:
        datafield = 'order_no';
        break;
      //case 3: //08/16/2019 Warranty 不要
      //  datafield = 'warranty';
      //  break;
      case 3:
        datafield = 'lent';
        break;
      case 4:
        datafield = 'returned';
        break;
      case 5:
        datafield = 'remarks';
        break;
      case 6:
        datafield = 'dispose_flg';
        break;
    }
    let searchText = this.myInput.val();
    let filtergroup = new jqx.filter();
    let filter_or_operator = 1;
    let filtervalue = searchText;
    let filtercondition = 'contains';
    let filter = filtergroup.createfilter('stringfilter', filtervalue, filtercondition);
    filtergroup.addfilter(filter_or_operator, filter);
    this.myGrid.addfilter(datafield, filtergroup);
    // apply the filters.
    this.myGrid.applyfilters();
  }

  //clear btn
  clearBtnOnClick(): void {
    this.myGrid.clearfilters();
  }

  //edit function
  rowValues: string = '';
  myGridOnCellBeginEdit(event: any): void {
    let args = event.args;
    this.selectedcell = args.datafield;
  };
  myGridOnCellEndEdit(event: any): void {
  };

  //print pdf
  printBtnOnClick() {
    this._reportService.showPrint(this.myGrid, 'Machine');

  };

  //export excel
  excelBtnOnClick() {
   this._reportService.exportExcel(this.myGrid, 'Machine' );
  };

  //getContractsDropDown() {
  //  this._contractService.getContractsForDropDown().subscribe((data) => {
  //    this.contractsSource.localdata = data;
  //  });
  //}

  //getContract(id) {
  //  this._contractService.getContractById(id).subscribe((data) => {
  //    this.contractsSource = data;
  //    this.contractValue = data;
  //  });
  //}

  onPageChanged(): void {
    this.myGrid.expandallgroups();
  }

  //Close Message
  closeSuccessMessage() {
    this.successMessage = null;
  }
  closeErrorMessage() {
    this.errorMessage = null;
  }
}

//****************************************************
// Popup
//****************************************************

@Component({
  selector: 'app-popup-machine',
  templateUrl: 'popup-machine.component.html',
  styleUrls: ['./machine-popup.component.css'],
})
export class PopupMachineComponent implements OnInit {
  title: string = "(Create)";
  Form: FormGroup;
  errorMessage: any;
  successMessage: any;
  selectedcell: any;
  delrows: Array<any> = [];
  deviceList: Array<any> = [];
  searchedList: Array<any> = [];
  user: any;
  setValueD: any;

  constructor(
    public dialogRef: MatDialogRef<PopupMachineComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _masterService: MasterService, private _machineService: MachineService,
    private _authService: AuthService,
    private _fb: FormBuilder, private _com: CommonService
  ) {
    var today = new Date();
    var todayStr = this._com.getDateTime(new Date());
    this.user = this._authService.getAuthLoginName();
    this.Form = this._fb.group({
      contract: null,
      machine_id: 0,
      contract_id: 0,
      device_id: 0,
      mac_address: ['', Validators.required],
      order_no: '',
      lent: todayStr,
      returned: todayStr,
      remarks: '',
      updated_by: this.user,
      updated_date: todayStr,
      dispose_flg: false
    })
  }

  ngOnInit() {
    this.getDropDownList();
    this.getMachineById(this.data.machine_id);
  }

  //ngDoCheck() {
    
  //} 

  //ngAfterContentInit() {
  //  this.setDropDownValue();
  //} 
  //ngAfterViewInit(): void {
  //  this.setDropDownValue();
  //}

  getDropDownList() {
    //Agent
    this._masterService.getDevices(true)
      .subscribe(data => {
        this.deviceList = data;
      });
  }
  getMachineById(id) {
    if (id > 0) {
      this.title = '(Edit/View)'
      this._machineService.getMachineById(id)
        .subscribe(
          res => {
            this.Form.setValue(res);
            this.onKey(res.mac_address);
          },
          error => this.errorMessage = error._body
      );
    }
  }

  getWidth(): any {
    return '100%';
  }

  getHeight(): any {
    return '70%';
  }

  //Save Data
  saveMachine() {
    //check form
    if (this.Form.invalid) {
      this.errorMessage = 'Please enter all required fields.';
      return;
    }

    this.errorMessage = null;
    this.successMessage = null;
    var today = new Date();
    var todayStr = this._com.getDateTime(new Date());
    this.Form.value.updated_by = this.user;
    this.Form.value.updated_date = todayStr;
    if (this.machine_id.value == 0) {
      this._machineService.addMachine(this.Form.value)
        .subscribe(
          data => {
            if (data > 0) {
              this.successMessage = "You have successfully added the data.";
              this.getMachineById(data);
            } else {
              this.errorMessage = "Failed to save the data. ";
            }
          },
          error => {
            this.successMessage = null;
            if (error != null) {
              this.errorMessage = error._body;
            }
            else {
              this.errorMessage = "Failed to save the data. ";
            }
          });
    }
    else {
      this._machineService.updateMachine(this.Form.value)
        .subscribe(
          data => {
            if (data > 0) {
              this.successMessage = "You have successfully updated the data.";
              this.getMachineById(data);
            } else {
              this.errorMessage = "Failed to update the data. ";
            }
          },
          error => {
            this.successMessage = null;
            if (error != null) {
              this.errorMessage = error._body;
            }
            else {
              this.errorMessage = "Failed to update the data. ";
            }
          });
    }
  }

  //Delete Data
  deleteMachine() {
    if (!confirm("Are you sure you want to delete this data?")) {
      console.log('no');
      return;
    }

    if (this.machine_id.value != 0) {

      let id = this.machine_id.value;

      this._machineService.deleteMachine(id)
        .subscribe(
          data => {
            if (data == 1) {
              this.dialogRef.close();
            }
            else {
              this.errorMessage = ' Failed to delete the data.';
            }
          },
          error => {
            if (error != null) {
              this.errorMessage = error._body;
            }
            else {
              this.errorMessage = "Failed to delete the data. ";
            }
          }
        )
    };
  }

  deviceOnSelect(event: any): void {
    let value = event.value;
    if (value > 0) {
      this._masterService.getDeviceById(value)
        .subscribe(
          data => {
            this.device_id.setValue(data.device_id);
            this.mac_address.setValue(data.mac_address);
            this.order_no.setValue(data.order_no);
          });
    }
    else {
      this.device_id.setValue(0);
      this.mac_address.setValue(null);
      this.order_no.setValue(null);
    }
  }

  // Receive user input and send to search method**
  onKey(value) {
    this.searchedList = [];
    //if (typeof value != "undefined" && value != null) {
    //  let filter = value.toLowerCase();
    //  for (let i = 0; i < this.deviceList.length; i++) {
    //    let option = this.deviceList[i];
    //    if (option.mac_address.toLowerCase().indexOf(filter) >= 0) {
    //      this.searchedList.push(option);
    //    }
    //  }
    //}
    if (typeof value != "undefined" && value != null && value != "") {
      this._masterService.getListDevicesForDropDownSearchListALL(value)
        .subscribe(
          res => {
            this.searchedList = res;
            //this.searchedList.push(res); //error
          },
          error => this.errorMessage = error._body
        );
    } else {
      this.device_id.setValue(0);
      this.mac_address.setValue("");
    }
  }

  //Close Message
  closeSuccessMessage() {
    this.successMessage = null;
  }
  closeErrorMessage() {
    this.errorMessage = null;
  }

  get contract() { return this.Form.get('contract'); }
  get machine_id() { return this.Form.get('machine_id'); }
  get contract_id() { return this.Form.get('contract_id'); }
  get device_id() { return this.Form.get('device_id'); }
  get mac_address() { return this.Form.get('mac_address'); }
  get order_no() { return this.Form.get('order_no'); }
  get lent() { return this.Form.get('lent'); }
  get returned() { return this.Form.get('returned'); }
  get remarks() { return this.Form.get('remarks'); }
  get dispose_flg() { return this.Form.get('dispose_flg'); }
  get updated_by() { return this.Form.get('updated_by'); }
  get updated_date() { return this.Form.get('updated_date'); }
}




// WEBPACK FOOTER //
// ./src/app/machine/machine-list.component.ts